module.exports = __webpack_public_path__ + "src/images/redux-logo.b4e23a502e44692d9f3c8b427ac23e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/redux-logo.png
// module id = 107
// module chunks = 0